(function() {
  const TRACKING_PARAMS = [
    'utm_source','utm_medium','utm_campaign','utm_term','utm_content',
    'fbclid', 'ttclid', 'msclkid', 'li_fat_id',
    'scclid', 'twclid', 'epik', 'ycclid', '_ke', 'adroll_click_id',
    'criteo_click_id', 'obclid', 'tbclid', 'rdt_cid'
  ];
  
  const GOOGLE_CLICK_IDS = ['gclid', 'wbraid', 'gbraid'];
  const COOKIE_DAYS = 90;
  
  const urlParams = new URLSearchParams(window.location.search);
  const foundParams = {};
  
  [...TRACKING_PARAMS, ...GOOGLE_CLICK_IDS].forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      foundParams[param] = value;
    }
  });
  
  if (Object.keys(foundParams).length === 0) {
    return;
  }
  
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    const encodedValue = encodeURIComponent(value);
    const domain = window.location.hostname;
    
    const cookieConfigs = [
      `${name}=${encodedValue}; expires=${expires}; path=/; domain=${domain}; SameSite=None; Secure`,
      `${name}=${encodedValue}; expires=${expires}; path=/; SameSite=None; Secure`,
      `${name}=${encodedValue}; expires=${expires}; path=/; SameSite=Lax; Secure`,
      `${name}=${encodedValue}; expires=${expires}; path=/; Secure`,
      `${name}=${encodedValue}; expires=${expires}; path=/`
    ];
    
    for (let i = 0; i < cookieConfigs.length; i++) {
      document.cookie = cookieConfigs[i];
      const check = document.cookie.split('; ').find(c => c.startsWith(`${name}=`));
      if (check) {
        return true;
      }
    }
    
    return false;
  }
  
  Object.entries(foundParams).forEach(([param, value]) => {
    setCookie(param, value, COOKIE_DAYS);
  });
  
  const originalWrapper = window.OptanonWrapper;
  window.OptanonWrapper = function() {
    if (typeof originalWrapper === 'function') {
      originalWrapper();
    }
    Object.entries(foundParams).forEach(([param, value]) => {
      setCookie(param, value, COOKIE_DAYS);
    });
  };
  
})();